const state = {
  component: {}
};

const getters = {
  editedPageComponent: (state) => state.component
};

const mutations = {
  SET_EDIT_PAGE_COMPONENT(state, data) {
    state.component = data;
  }
};

export default {
  state,
  getters,
  mutations
};
